// extracted by mini-css-extract-plugin
export default {"user-name-box":"UserProfile_user-name-box__lPqq1","name":"UserProfile_name__hDeAY","profile-menu":"UserProfile_profile-menu__Ep4hu"};